export default __webpack_public_path__ + "static/media/gallery-1-3.e66d0cb3.jpg";